module.exports = {
      id: "prothomalo-trust-usage",
      viewBox: "0 0 260 65",
      url: "/" + "sprite-f96a299a5e63739e5b36582e48c149a3.svg#prothomalo-trust",
      toString: function () {
        return this.url;
      }
    }